import React from 'react';
import { connect } from 'react-redux';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { renderQuota } from '../../../helpers/HelperMethods';
import { limitVersioning } from '../../../GlobalConst/globalConst';
import InfoTooltip from '../../formFields/InfoTooltip';

class InfoTable extends React.Component {

    render() {

        const toolTipContent =
        <span>
                This site includes 10GB of free storage. (Free allocation is subject to future adjustment). If your usage exceeds 10GB, billing applies to the total storage:<br />
                <br />
                - Calculation: You are charged for 45% of Total Storage<br />&emsp;at 0.15 USD per GB/month.<br />
                - Example: A 60GB site costs 4.05 USD/month.<br />&emsp;[45% of 60GB * 0.15 USD = 4.05 USD]<br />
                <br />
                Charges are prorated and billed quarterly to the Admin cost center.<br />
        </span>;

        return (
            this.props.onlineLocation !== null &&
                <div style={tableStyle}>
                        <MessageBar messageBarType={MessageBarType.info}>
                            <div>{ this.props.onlineLocation ? <span>You are about to request the creation of </span> : <span>You are going to create </span> } {this.props.locationObject.name} Site</div>
                            <table>
                                <tbody>
                                    <tr><td style={labelColumn}>Yearly Cost: </td><td><span>{this.props.locationObject.cost} { this.props.onlineLocation ? <span><InfoTooltip content={toolTipContent} /></span> : <span>(irrespectively of used storage)</span> }</span></td></tr>
                                    { !this.props.onlineLocation && <tr><td style={labelColumn}>Default quota: </td><td>{renderQuota(this.props.quota)}</td></tr> }
                                    { !this.props.isSummaryInfo && <tr><td style={labelColumn}>Default versioning settings: </td><td>File versioning is enabled for all libraries with a count limit of {limitVersioning.versionsLimit} and a time limit of {limitVersioning.versionsDays} days.</td></tr> }
                                </tbody>
                            </table>
                            { this.props.onlineLocation && !this.props.isSummaryInfo ? <span>Please note that requesting to create a SharePoint Site will require your line manager’s approval.  </span> : <div></div> }
 
                            {this.props.onlineLocation && this.props.isSummaryInfo ? 
                            <a href="https://go.insideplus.abb.com/information-systems/gf-is/use-the-tools/sharepoint-sites" target="_blank" rel="noopener noreferrer" style={{paddingLeft: 0}}>
                            Read more about the different SharePoint sites features </a>
                            :
                            <a href="https://go.insideplus.abb.com/information-systems/gf-is/use-the-tools/sharepoint-sites" target="_blank" rel="noopener noreferrer" style={{paddingLeft: 0}}>
                            Learn more about SharePoint and its various features here. </a>}

                            <div>{this.props.locationObject.remarks}</div>
                        </MessageBar>
                </div>
                
        );
    }

}

const tableStyle = {
    margin: '10px 0'
}

const labelColumn = {
    width: '165px',
    verticalAlign: 'top',
    paddingLeft: '15px'
}

const mapStateToProps = state => ({
    onlineLocation: state.newSite.OnlineLocation,
    quota: state.newSite.QuotaSize,
    locationObject : state.newSite.Location
});


export default connect(mapStateToProps, null)(InfoTable);


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/InfoTable.js